import { module } from 'modujs';
import gsap from "gsap";
import { onWidthResize } from '../utils/tickers';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.cards = this.el.querySelectorAll('.c-features_card');

        this.el.querySelectorAll('[data-collapse]').forEach((collapse) => {
            const collapseToggle = collapse.querySelector('[data-collapse-toggle]');
            const collapseContent = collapse.querySelector('[data-collapse-content]');
            const collapseContentInner = collapse.querySelector('[data-collapse-content-inner]');

            if (!collapseToggle || !collapseContent || !collapseContentInner) {
                return;
            }

            collapseToggle.addEventListener('click', () => {
                const contentHeight = collapseContentInner.offsetHeight;
                collapse.toggleAttribute('data-collapse-opened');
                gsap.to(collapseContent, {
                    height: collapse.hasAttribute('data-collapse-opened') ? contentHeight : 0,
                    ease: 'expo.out',
                    duration: 0.8,
                    onComplete: () => {
                        this.call('resize', 'Scroll');
                    }
                });
            });
        });

        this.sameHeight();
        onWidthResize(() => {
            this.resizeCollapsesContents()
            this.sameHeight()
        });
    }

    resizeCollapsesContents() {
        this.el.querySelectorAll('[data-collapse-opened]').forEach((collapse) => {
            const collapseContentInner = collapse.querySelector('[data-collapse-content-inner]');
            const collapseContent = collapse.querySelector('[data-collapse-content]');

            if (!collapseContentInner || !collapseContent) {
                return;
            }

            collapseContent.style.height = collapseContentInner.offsetHeight + 'px';
        });
    }

    sameHeight() {
        let heights = [];

        for (var i = 0; i < this.cards.length; i++) {
            this.cards[i].setAttribute('style', '');
        }
    
        for (var i = 0; i < this.cards.length; i++) {
            heights.push(this.cards[i].offsetHeight);
        }

        if (!heights.length) {
            return;
        }

        const tallest = Math.max(...heights);

        for (var i = 0; i < this.cards.length; i++) {
            this.cards[i].style.height = tallest + "px";
        }

        setTimeout(() => {
            this.call('resize', 'Scroll');
        }, 100);
    }
}
